module.exports = __webpack_public_path__ + "img/toast_white.e555ab17.svg";